import * as Api from "@modules/api";
import { thunkErrorHandler } from "@utils/helpers/thunkErrorHandler";
import { thunkResponseCheckerSdk } from "@utils/helpers/thunkResponseCheckerSdk";
import { ApiMethod } from "@utils/types/common";

export const canStartQuiz: ApiMethod<string, boolean, void> = async (
  body,
  { dispatch, rejectWithValue }
) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Api.Server.Server_QuizTries_Client(
          undefined,
          Api.apiClient
        );

        return client.quizTries_canStartQuizCheck_get_V1("1", body);
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue,
    "page"
  );
};

export const getQuizActions: ApiMethod<
  Api.Server.GetContentEntitiesQuizActionInput,
  Api.Server.ContentEntityQuizActionOutput[],
  void
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Api.Server.Server_QuizTries_Client(
          undefined,
          Api.apiClient
        );

        return client.quizTries_getContentEntitiesQuizAction_post_V1(body);
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue,
    "page"
  );
};

export const getQuizInstructions: ApiMethod<
  string,
  Api.Server.GetQuizInstructionsOutput,
  void
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Api.Server.Server_QuizTries_Client(
          undefined,
          Api.apiClient
        );

        return client.quizTries_getQuizInstructions_get_V1("1", body);
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue,
    "page"
  );
};

export const startQuiz: ApiMethod<
  Api.Server.StartQuizTryInput,
  Api.Server.StartQuizTryOutput,
  void
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Api.Server.Server_QuizTries_Client(
          undefined,
          Api.apiClient
        );

        return client.quizTries_startQuiz_post_V1(body);
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue,
    "page"
  );
};

export const submitAnswer: ApiMethod<
  Api.Server.SubmitAnswerInput,
  void,
  void
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(
        async () => {
          const client = new Api.Server.Server_QuizTries_Client(
            undefined,
            Api.apiClient
          );

          return client.quizTries_submitAnswer_put_V1(body);
        },
        rejectWithValue,
        false
      );
    },
    dispatch,
    rejectWithValue,
    "page"
  );
};

export const completeQuiz: ApiMethod<
  Api.Server.CompleteQuizTryInput,
  Api.Server.GetQuizResultWithCertificatesOutput,
  void
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Api.Server.Server_QuizTries_Client(
          undefined,
          Api.apiClient
        );

        return client.quizTries_complete_put_V1(body);
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue,
    "page"
  );
};

export const cancelQuiz: ApiMethod<
  Api.Server.CancelQuizTryInput,
  void,
  void
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(
        async () => {
          const client = new Api.Server.Server_QuizTries_Client(
            undefined,
            Api.apiClient
          );

          return client.quizTries_cancel_put_V1(body);
        },
        rejectWithValue,
        false
      );
    },
    dispatch,
    rejectWithValue,
    "page"
  );
};

export const getQuestionsAndAnswers: ApiMethod<
  number,
  Api.Server.UserQuizQuestionsAndAnswersOutput[],
  void
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Api.Server.Server_QuizTries_Client(
          undefined,
          Api.apiClient
        );

        return client.quizTries_getQuizQuestionsAndAnswers_get_V1(body);
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue,
    "page"
  );
};
